module.exports = __webpack_public_path__ + "static/media/help2.c12bc4e8.svg";